// extracted by mini-css-extract-plugin
export default {"placeholder":"co6RCvFclB","input":"bCV6R99Rss","inputLabel":"jlDcEeZFpk","dark":"nlcPoG5bM7"};